import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-haut.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-bottom-doodle.svg';
export default {
  name: 'ThumbnailListArrowButton',
  props: {
    arrowDirection: {
      type: String,
      default: 'up',
      validator: function validator(value) {
        return ['up', 'down'].includes(value);
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonData: function buttonData() {
      var data = {
        label: 'buttonLabelUp',
        icon: 'chevron-haut'
      };

      if (this.arrowDirection === 'down') {
        data.label = 'buttonLabelDown';
        data.icon = 'chevron-bottom-doodle';
      }

      return data;
    }
  }
};